// extracted by mini-css-extract-plugin
module.exports =  {"icon":"icon--hsQkc","default":"default--k8hJc","no-fill":"no-fill--qzZqP","noFill":"no-fill--qzZqP","landscape":"landscape--nnOxp"};